import { applyTokens } from "../../../utilities/applyTokens.js";
import { createLazyIcon } from "../../../utilities/createLazyIcon.js";
const select = (tokens) => {
    const { core, semantic } = tokens;
    const { dropdown, list } = tokens.component;
    const ExpandDownIcon = createLazyIcon(() => import("@diligentcorp/atlas-react-icons/dist/esm/lens/ExpandDown.js"));
    return {
        MuiSelect: {
            defaultProps: {
                IconComponent: ExpandDownIcon,
                MenuProps: {
                    disablePortal: true,
                },
            },
            styleOverrides: {
                root: {
                    // Note: this also takes effect in NativeSelect
                    cursor: "pointer",
                    "& .MuiMenuItem-root": Object.assign(Object.assign(Object.assign({ boxShadow: "none", height: "auto", gap: "0" }, applyTokens(list.item)), applyTokens(dropdown.list.item)), { "&:focus": {
                            outline: "none",
                        }, "& .MuiCheckbox-root": Object.assign(Object.assign({}, applyTokens(dropdown.list.item.checkbox)), { input: {
                                position: "relative",
                                width: core.spacing["3"].value,
                                height: core.spacing["3"].value,
                            }, svg: {
                                right: "unset",
                            } }) }),
                    "& .MuiListSubheader-root": Object.assign(Object.assign({}, applyTokens(dropdown.list.item)), { borderBottom: `${semantic.borderWidth.thin.value} solid ${semantic.color.ui.divider.secondary.value} !important`, ":not(:first-of-type)": {
                            marginTop: core.spacing["1_5"].value,
                        } }),
                    "& .MuiListItemText-root": {
                        textWrap: "wrap",
                        overflowWrap: "break-word",
                        whiteSpace: "pre-wrap",
                    },
                    "& .MuiPaper-root": {
                        marginTop: dropdown.container.marginTop.value,
                        maxHeight: "275px",
                    },
                    "& .MuiList-root": {
                        maxHeight: "275px",
                    },
                    "svg:not([class])": Object.assign(Object.assign({}, applyTokens(list.item.content.icon)), { fontSize: semantic.iconSize.lg.value, right: core.spacing["2"].value, position: "absolute", transform: "none", display: "inline-block", userSelect: "none", pointerEvents: "none" }),
                },
                select: {
                    "&&&": {
                        paddingRight: `${core.spacing["5"].value} !important`,
                    },
                },
                multiple: {
                    height: "auto !important",
                    minHeight: core.spacing["5"].value,
                    svg: {
                        minHeight: core.spacing["2_5"].value,
                        minWidth: core.spacing["2_5"].value,
                    },
                    "&&&": {
                        paddingRight: `${core.spacing["5"].value} !important`,
                    },
                },
            },
        },
        MuiNativeSelect: {
            defaultProps: {
                IconComponent: ExpandDownIcon,
            },
            styleOverrides: {
                multiple: {
                    height: "auto",
                    "&&&": {
                        padding: 0,
                        height: "auto",
                    },
                },
            },
        },
    };
};
export default select;
//# sourceMappingURL=select.js.map